/**
 * Kép tömböt rendez
 * isPreview: első kép (index pic)
 */
export default function () {
	return function (imagesArray) {
		let retValue = [];
		if (Array.isArray(imagesArray)) {
			let first = imagesArray.find(e => e.isPreview);
			let indexFirst = imagesArray.indexOf(first);
			if (first) {
				retValue.push(first);
			}
			imagesArray.forEach((element, index) => {
				if (index != indexFirst) {
					retValue.push(element);
				}
			});
		}
		return retValue;
	};
}
